<template>
  <!-- begin::Page loader -->
  <div class="page-loader page-loader-logo">
    <img src="synergy-fox-wide.svg" class="h-80" style="max-width:130px" />
    <div class="spinner" v-bind:class="spinnerClass || 'spinner-primary'"></div>
  </div>
  <!-- end::Page Loader -->
</template>

<script>
export default {
  name: "Loader",
  props: {
    logo: String,
    spinnerClass: String,
  },
};
</script>
